import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import AppointmentOverview from "./AppointmentOverview.js";
const AppointmentOverviewContainer = ({
  appointment,
  store,
  isStoreLoading,
  ...props
}) => {
  const { getLabel } = useIntl();
  const addressData = React.useMemo(
    () => store ? {
      storeName: store.name,
      streetName: store.streetName,
      town: store.town,
      streetNumber: store.streetNumber ?? "",
      additionalStreetInfo: store.additionalStreetInfo ?? "",
      postalCode: store.postalCode ?? ""
    } : void 0,
    [store]
  );
  const labels = React.useMemo(
    () => ({
      child: getLabel("appointments.component.appointmentOverview.child"),
      additionalInformation: getLabel(
        "appointments.component.appointmentOverview.additionalInformation"
      )
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement(
    AppointmentOverview,
    {
      ...props,
      appointment,
      labels,
      addressData,
      isStoreLoading
    }
  );
};
export {
  AppointmentOverviewContainer as default
};
//# sourceMappingURL=AppointmentOverviewContainer.js.map
